// extracted by mini-css-extract-plugin
export var bounce = "_kb-1";
export var generatingText = "_kb-6";
export var lightning = "_kb-4";
export var popup = "_kb-5";
export var progressBar = "_kb-7";
export var progressFill = "_kb-8";
export var progressShimmer = "_kb-9";
export var progressText = "_kb-a";
export var shimmer = "_kb-3";
export var uploadIcon = "_kb-0";
export var uploadingText = "_kb-2";